export default __webpack_public_path__ + "img/background_phones.a568c9e1.svg";